import { ODPSParser } from './ODPSParser';

class ODPSAnalyzer {

    constructor(text, schemas) {
        this.parser = new ODPSParser(text);
        this.schemas = schemas;
        this.results = [];
    }

    contains(target) {
        let conf;
        for (let hint of this.results) {
            if (ODPSAnalyzer.contains2(hint.position, target)) {
                if (ODPSAnalyzer.isInnerOf(hint.position, conf?.position)) {
                    conf = hint;
                }
            }
        }
        return conf;
    }

    static contains2(from, target) {
        return (target.lineNumber === from.start.line &&
            target.lineNumber === from.stop.line &&
            target.column >= from.start.column &&
            target.column <= from.stop.column) ||
            (target.lineNumber >= from.start.line && target.lineNumber <= from.stop.line);
    }

    static isInnerOf(from, target) {
        if (target === undefined) {
            return true;
        }
        return (from.start.line >= target.start.line && from.stop.line <= target.stop.line) ||
            (from.start.line === target.start.line &&
                from.stop.line === target.stop.line &&
                from.start.column >= target.start.column &&
                from.stop.column <= target.stop.column);
    }

    analyze() {
        const block = this.parser.parseBlock();
        block.forEach(stmt => this.processStatement(stmt));
    }

    processStatement(stmt) {
        switch (stmt.id) {
            case 'SELECT':
                this.processSelectStatement(stmt);
                break;
            case 'INTERSECT':
            case 'UNION':
            case 'EXCEPT':
            case 'MINUS':
            case 'INTERSECT_ALL':
            case 'UNION_ALL':
            case 'EXCEPT_ALL':
            case 'MINUS_ALL':
            case 'INTERSECT_DISTINCT':
            case 'UNION_DISTINCT':
            case 'EXCEPT_DISTINCT':
            case 'MINUS_DISTINCT':
                this.processStatement(stmt.lhs);
                this.processStatement(stmt.rhs);
                break;
            default:
                console.log('invalid statement', stmt);
                break;
        }
    }

    processSelectStatement(stmt) {
        if (stmt.id !== 'SELECT') {
            throw 'invalid select statement';
        }

        const conf = {
            position: stmt.position,
            columns: [],
            alias: {},
            schemas: {}
        };
        if (stmt.fromClause === undefined) {
            this.results.push({ position: stmt.position });
            return this.processSelectColumns(conf, stmt.projection?.columns)
        }

        const from = stmt.fromClause;
        if (from.join !== undefined) {
            this.processJoinClause(from, conf);
            this.results.push(conf);
        } else if (from.schema !== undefined) {
            this.processTableRef(from, conf);
            this.results.push(conf);
        } else if (from.subQuery !== undefined) {
            this.processSubQuery(from, conf);
            this.results.push(conf);
        }
        return this.processSelectColumns(conf, stmt.projection?.columns);
    }

    processSelectColumns(conf, columns) {
        if (columns === null || columns === undefined) {
            return {};
        }
        const projections = {};
        for (let column of columns) {
            if (column.col === '*') {
                for (let original of conf.columns) {
                    projections[typeof original === 'string' ? original : original.name] = original;
                }
                continue;
            }
            let field, original_name;
            if (column.col.dot !== undefined) {
                field = conf.schemas[column.col.dot]
                    ?.columns
                    ?.find(x => x === column.col.field || x.name === column.col.field);
                original_name = column.col.field;
                projections[original_name] = field;
            } else if (column.col.id !== undefined) {
                field = conf.columns.find(x => x === column.col.id || x.name === column.col.id);
                original_name = column.col.id
                projections[original_name] = field;
            } else {
                field = { type: '', name: '_col1', comment: '' };
            }

            if (column.alias !== undefined) {
                delete projections[original_name];
                projections[column.alias] = field !== undefined ? JSON.parse(JSON.stringify(field)) : undefined;
            }
        }
        return projections;
    }

    processJoinClause(clause, conf) {
        if (clause.lhs.join !== undefined) {
            this.processJoinClause(clause.lhs, conf);
        } else if (clause.lhs.schema !== undefined) {
            this.processTableRef(clause.lhs, conf);
        } else if (clause.lhs.subQuery !== undefined) {
            this.processSubQuery(clause.lhs, conf);
        }
        if (clause.rhs.join !== undefined) {
            this.processJoinClause(clause.rhs, conf);
        } else if (clause.rhs.schema !== undefined) {
            this.processTableRef(clause.rhs, conf);
        } else if (clause.rhs.subQuery !== undefined) {
            this.processSubQuery(clause.rhs, conf);
        }
    }

    processTableRef(ref, conf) {
        const schema = this.schemas[ref.schema];
        if (ref.alias !== undefined) {
            conf.alias[ref.alias] = ref.schema;
            conf.schemas[ref.alias] = schema;
        }
        conf.schemas[ref.schema] = schema;
        if (schema !== undefined) {
            for (let col of schema.columns) {
                conf.columns.push(col);
            }
        }
    }

    processSubQuery(ref, conf) {
        const projections = this.processSelectStatement(ref.subQuery);
        const columns = Object.keys(projections).map(name => {
            let field = projections[name];
            if (field === undefined) {
                return { name };
            }
            if (field.name !== undefined) {
                field.name = name;
            } else {
                field = name;
            }
            conf.columns.push(field);
            return field;
        });
        conf.schemas[ref.alias] = { columns };
        conf.alias[ref.alias] = '';
    }
}

export default ODPSAnalyzer;